import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import TagManager from 'react-gtm-module';

import CalendarFilter from "../childrens/calendarFilter/.mixins";
import Card from "../childrens/cards/.mixins/index";
import Modal from "../childrens/detalheOpcaoRecebimento/.mixins/Modal";

export default (props) => {
    const date = new Date();
    date.setDate(date.getDate() + 30);

    const [dtInitial, setDtInitial] = useState(new Date());
    const [dtEnd, setDtEnd] = useState(date);
    const [isOpenModalDetail, setIsOpenModalDetail] = useState(false);

    function ChangeModalDetailState() {
        setIsOpenModalDetail(!isOpenModalDetail);

        //fechar
        if (isOpenModalDetail) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'event',
                    eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                    eventAction: 'clique:botao',
                    eventLabel: 'fechar',
                }
            });
        }
    }

    return (
        <Grid container direction="column" justifyContent="center">
            <CalendarFilter
                dtInitial={dtInitial}
                setDtInitial={setDtInitial}
                dtEnd={dtEnd}
                setDtEnd={setDtEnd}
            />
            <Card
                dtInitial={dtInitial}
                dtEnd={dtEnd}
                props={props}
                ChangeModalDetailState={ChangeModalDetailState}
            />
            <Modal
                ChangeModalDetailState={ChangeModalDetailState}
                isOpenModalDetail={isOpenModalDetail}
                props={props}
            />
        </Grid>
    );
};
